import { Table } from 'antd'

import useTranslations from '../../hooks/useTranslations'

const ANTDTable = ({ pagination, columns, dataSource, bordered, ...props }) => {
  const { t } = useTranslations()
  return (
    <Table
      {...{ columns, dataSource, bordered }}
      {...props}
      pagination={pagination && { showSizeChanger: false, ...pagination }}
      locale={{ emptyText: t('txt_NoData') }}
    />
  )
}

export default ANTDTable

const ANTDTableRow = ({ ...props }) => {
  return <Table.Summary.Row {...props} />
}
const ANTDTableCell = ({ ...props }) => {
  return <Table.Summary.Cell {...props} />
}
export { ANTDTableCell, ANTDTableRow }
